module.exports = __webpack_public_path__ + "img/firstoptionsfertility-logo.9a2ec027.svg";